// const BASE_URL = "http://localhost:3001";
const BASE_URL = "http://api.pointnest.trangotechdevs.com:3061";
// APIs design from Shaheer
const API_URL = BASE_URL + "/api/admin/";

const INITIAL_TOKEN = "3390346c-ad76-4664-a9fd-05e8a90bf71e";

export { API_URL, BASE_URL, INITIAL_TOKEN };
